const HTTP_URL_REGEX = /^https?:\/\/([^\s"]+)$/;
const SCHEME_REGEX = /^[a-zA-Z][\w+.-]*:\/\//;

export const isValidUrl = (url: string) => {
  const afterScheme = HTTP_URL_REGEX.exec(url)?.[1];
  if (!afterScheme) return false;

  return afterScheme.slice(1, -1).includes('.');
};

export const normalizeUrl = (url: string) => {
  const trimmed = url.trim();
  if (!trimmed) return '';
  return SCHEME_REGEX.test(trimmed) ? trimmed : `https://${trimmed}`;
};
